import { Box, BoxProps } from '@everlywell/ui-kit';
import React, { useRef } from 'react';
import { TrackProps, trackComponentVisibility } from 'utils/analytics';

type TrackVisibilityWrapperProps = BoxProps & {
  label: string;
  children: React.ReactNode;
  slug?: string;
  centerContent?: boolean;
  flexContainer?: boolean;
  width?: string;
  extraTrackProps?: TrackProps['data'];
};

export const TrackVisibilityWrapper = ({
  label,
  children,
  slug,
  centerContent,
  flexContainer,
  width,
  extraTrackProps,
  ...boxProps
}: TrackVisibilityWrapperProps) => {
  const ref = useRef(null);
  trackComponentVisibility(ref, {
    label,
    ...(slug && {
      slug,
    }),
    ...extraTrackProps,
  });

  return (
    <Box
      {...boxProps}
      ref={ref}
      style={{
        margin: centerContent ? '0 auto' : '0',
        display: flexContainer ? 'flex' : 'block',
        width: width || undefined,
        ...boxProps.style,
      }}
    >
      {children}
    </Box>
  );
};
export default TrackVisibilityWrapper;
